export default __webpack_public_path__ + "static/media/2_1_hl.e7a57f7b.png";